import { InfoElement } from 'components'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatUnits, getDifferenceWithPrecision, handleNullCase } from 'utils'

function Conversion({ conversionCompared, conversionCurrent, conversionPercentagePoints }) {
  const { t: translate } = useTranslation()
  const getPercentage = conversion =>
    conversion === null ? handleNullCase(conversion) : `${formatUnits(conversion * 100, translate)}%`
  const current = getPercentage(conversionCurrent)
  const compared = handleNullCase(getPercentage(conversionCompared))
  const ppPercentDifference = getDifferenceWithPrecision({
    handleNullCase: true,
    number: conversionPercentagePoints === null ? conversionPercentagePoints : conversionPercentagePoints / 100,
    suffix: ` ${translate('revenue.pp')}`,
    translate,
  })

  return (
    <div className="store-result-compare">
      <div>
        <b>{current} /</b> {compared}
      </div>

      <InfoElement percentDifference={ppPercentDifference} />
    </div>
  )
}

Conversion.propTypes = {
  conversionCompared: PropTypes.number,
  conversionCurrent: PropTypes.number,
  conversionPercentagePoints: PropTypes.number,
}

export default Conversion
